import styles from "./NavMenu.module.css";

export type NavTab = "about" | "product" | "lens24" | "place";

const items: { key: NavTab; label: string }[] = [
  { key: "about", label: "ABOUT" },
  { key: "product", label: "PRODUCT" },
  { key: "lens24", label: "LENS24" },
  { key: "place", label: "PLACE" },
];

interface Props {
  activeTab?: NavTab;
  onSelect?: (tab: NavTab) => void;
  expanded?: boolean;
  revealed?: boolean;
  closing?: boolean;
}

export default function NavMenu({
  activeTab = "about",
  onSelect,
  expanded = false,
  revealed = false,
  closing = false,
}: Props) {
  return (
    <nav className={styles.nav}>
      {items.map((item, i) => {
        const isActive = activeTab === item.key;
        // revealed 전: 스태거 딜레이가 걸린 entering 상태, revealed 후: 호버와 동일한 속도의 open 상태
        // (entering의 딜레이가 계속 남아있으면 호버 해제 시에도 그 딜레이를 물려받아 버벅이므로 분리)
        const phaseClass = revealed ? styles.open : expanded ? styles.entering : "";
        return (
          <button
            key={item.key}
            type="button"
            style={{ "--item-index": i } as React.CSSProperties}
            className={[
              styles.item,
              isActive ? styles.active : styles.inactive,
              phaseClass,
              closing ? styles.closing : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={() => onSelect?.(item.key)}
          >
            <span className={styles.labelWrap}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.label} aria-hidden="true">
                {item.label}
              </span>
            </span>
          </button>
        );
      })}
    </nav>
  );
}
